export const AS_FETCH_RESULTS = 'AS_FETCH_RESULTS'
export const AS_FETCH_RESULTS_REQUESTED = 'AS_FETCH_RESULTS_REQUESTED'
export const AS_FETCH_RESULTS_SUCCESS = 'AS_FETCH_RESULTS_SUCCESS'
export const AS_FETCH_RESULTS_FAILED = 'AS_FETCH_RESULTS_FAILED'
export const AS_LOCATION_CHANGED = 'AS_LOCATION_CHANGED'
export const AS_LOCATION_SET = 'AS_LOCATION_SET'
export const AS_CANCERTYPE_CHANGED = 'AS_CANCERTYPE_CHANGED'
export const AS_SEARCH_ENTITY_TYPE_CHANGED = 'AS_SEARCH_ENTITY_TYPE_CHANGED'
export const AS_DOCTOR_TYPE_GROUPS_CHANGED = 'AS_DOCTOR_TYPE_GROUPS_CHANGED'
export const AS_DOCTOR_TYPES_CHANGED = 'AS_DOCTOR_TYPES_CHANGED'
export const AS_TREATMENT_TYPES_CHANGED = 'AS_TREATMENT_TYPES_CHANGED'
export const AS_GET_FORM_INITIALISATION_DATA_SUCCESS = 'AS_GET_FORM_INITIALISATION_DATA_SUCCESS'
export const AS_GET_FORM_INITIALISATION_DATA_FAILED = 'AS_GET_FORM_INITIALISATION_DATA_FAILED'
export const AS_PUBLIC_ONLY_CHANGED = 'AS_PUBLIC_ONLY_CHANGED'
export const AS_LANGUAGE_CHANGED = 'AS_LANGUAGE_CHANGED'
export const AS_GENDER_CHANGED = 'AS_GENDER_CHANGED'
export const AS_CHILDREN_AND_YOUTH_SERVICES_CHANGED = 'AS_CHILDREN_AND_YOUTH_SERVICES_CHANGED'
export const AS_CHILDREN_AND_YOUTH_TEAMS_CHANGED = 'AS_CHILDREN_AND_YOUTH_TEAMS_CHANGED'

const defaultSearchEntityType = 'specialists'

const initialState = {
    isFetchingResults: false,
    locationHasEror: false,
    cancerTypeHasError: false,
    publicOnly: false,
    asFormInitialisationData: {}
}

export default (state = initialState, action) => {
    let newState = null;
  switch (action.type) {
    case AS_FETCH_RESULTS:
      return {
        ...state
      }

    case AS_FETCH_RESULTS_REQUESTED:
      return {
        ...state,
        isFetchingResults: true
      }

    case AS_FETCH_RESULTS_SUCCESS:
      return {
        ...state,
        isFetchingResults: false
      }

    case AS_FETCH_RESULTS_FAILED:
      return {
        ...state,
        isFetchingResults: false
      }

    case AS_LOCATION_CHANGED:
      return {
        ...state,
        location: action.value,
        locationHasEror: !action.value
      }

    case AS_CANCERTYPE_CHANGED:
      return {
        ...state,
        cancerType: action.value,
        cancerTypeHasError: !action.value
      }

    case AS_PUBLIC_ONLY_CHANGED:
      return {
        ...state,
        publicOnly : action.value
      }
      
    case AS_CHILDREN_AND_YOUTH_TEAMS_CHANGED:
      return {
        ...state,
        childrenAndYouthTeams : action.value
      }
      
    case AS_CHILDREN_AND_YOUTH_SERVICES_CHANGED:
      return {
        ...state,
        childrenAndYouthServices : action.value
      }

    case AS_SEARCH_ENTITY_TYPE_CHANGED:
      return {
        ...state,
        searchEntityType: action.value,
      }

    case AS_GET_FORM_INITIALISATION_DATA_SUCCESS:
      return {
        ...state,
        asFormInitialisationData: action.value,
        searchEntityType: action.value.searchEntityTypeFromQuery || defaultSearchEntityType,
        publicOnly: action.value.publicOnlyFromQuery
      }
      
    case AS_DOCTOR_TYPES_CHANGED:
      newState = {
        ...state
      }
      if(newState && newState.asFormInitialisationData && newState.asFormInitialisationData.DoctorTypeGroups){
        newState.asFormInitialisationData.DoctorTypeGroups = newState.asFormInitialisationData.DoctorTypeGroups.map((c, i) => { 
          c.DoctorTypes = c.DoctorTypes.map((b, j) => { 
            b.Name == action.value.Name && (b.checked = action.value.checked);
            return b;
          });
          return c;
        });
      }
      return newState;


    case AS_DOCTOR_TYPE_GROUPS_CHANGED:
      newState = {
        ...state
      }
      if(newState && newState.asFormInitialisationData && newState.asFormInitialisationData.DoctorTypeGroups){
        newState.asFormInitialisationData.DoctorTypeGroups = newState.asFormInitialisationData.DoctorTypeGroups.map((c, i) => { 
            if (c.Name == action.value.Name) {
                c.checked = action.value.checked;
                c.DoctorTypes = c.DoctorTypes.map((b, j) => {
                    b.checked = false;
                    return b;
                });
            }
          return c;
        });
      }
      return newState;

    case AS_TREATMENT_TYPES_CHANGED:
      newState = {
        ...state
      }
      if(newState && newState.asFormInitialisationData && newState.asFormInitialisationData.TreatmentTypes){
        var foundIndex = newState.asFormInitialisationData.TreatmentTypes.findIndex(x => x.Name == action.value.Name);
        newState.asFormInitialisationData.TreatmentTypes[foundIndex].checked = action.value.checked;
      }
      return newState;

    case AS_LANGUAGE_CHANGED:
      return {
        ...state,
        language: action.value
      }

    case AS_GENDER_CHANGED:
      return {
        ...state,
        gender: action.value
      }

    default:
      return state
  }
}

export const fetchResults = () => {
  return dispatch => {
    dispatch({
      type: AS_FETCH_RESULTS_REQUESTED
    })

    dispatch({
      type: AS_FETCH_RESULTS
    })
  }
}

export const locationChanged = (l) => {
    return dispatch => {
        l && l.id && createCookie('CURRENTLOC', l.id, 365);
        l && l.text && createCookie('CURRENTLOCT', l.text, 365);
        dispatch({
            type: AS_LOCATION_CHANGED,
            value: l
        })
    }
}

export const locationSet = (l) => {
    return dispatch => {
        l && (l.id = readCookie('CURRENTLOC'));
        l && (l.text = readCookie('CURRENTLOCT'));
        dispatch({
            type: AS_LOCATION_CHANGED,
            value: l
        })
    }
}

export const cancerTypeChanged = (ct) => {
    return dispatch => {
        ct && ct.id && createCookie('CURRENTCT', ct.id, 365);
        ct && ct.text && createCookie('CURRENTCTT', ct.text, 365);
        dispatch({
            type: AS_CANCERTYPE_CHANGED,
            value: ct
        })
    }
}

export const publicOnlyChanged = (e) => {
    return dispatch => {
        dispatch({
            type: AS_PUBLIC_ONLY_CHANGED,
            value: e.target.checked
        })
    }
}

export const childrenAndYouthServicesChanged = (e) => {
    return dispatch => {
      dispatch({
          type: AS_CHILDREN_AND_YOUTH_SERVICES_CHANGED,
          value: e && e.id
      })
  }
}

export const childrenAndYouthTeamsChanged = (e) => {
  return dispatch => {
    dispatch({
        type: AS_CHILDREN_AND_YOUTH_TEAMS_CHANGED,
        value: e && e.id
    })
}
}

export const doctorTypesChanged = (dt) => {
  return dispatch => {
      dispatch({
          type: AS_DOCTOR_TYPES_CHANGED,
          value: { Name : dt.target.value, checked: dt.target.checked }
      })
  }
}

export const doctorTypeGroupsChanged = (dtg) => {
  return dispatch => {

      dispatch({
          type: AS_DOCTOR_TYPE_GROUPS_CHANGED,
          value: { Name : dtg.target.value, checked: dtg.target.checked }
      })
  }
}

export const treatmentTypesChanged = (ct) => {
    return dispatch => {

        dispatch({
            type: AS_TREATMENT_TYPES_CHANGED,
            value: { Name :ct.target.value, checked: ct.target.checked }
        })
    }
}

export const searchEntityTypeChanged = (e) => {
    return dispatch => {
        dispatch({
            type: AS_SEARCH_ENTITY_TYPE_CHANGED,
            value: e.target.value
        })
    }
}

export const languageChanged = (la) => {
  return dispatch => {
      dispatch({
          type: AS_LANGUAGE_CHANGED,
          value: la
      })
  }
}

export const genderChanged = (ge) => {
  return dispatch => {
      dispatch({
          type: AS_GENDER_CHANGED,
          value: ge
      })
  }
}

var baseUrl = '/api/search/';

export const getFormInitialisationData = (queryStringFilters) => {
    return dispatch => {
        fetch(baseUrl + 'as-form-initialisation-data', {
            credentials: 'include',
            method: 'GET', // or 'PUT'
            headers:{
              'Accept': 'application/json'
            }
          }).then(res => {
            if(!res.ok)
            {
              throw Error(res.statusText);
            }
            return res.json();
          })
          .then(response => {

            if(response && response.TreatmentTypes){
                response.TreatmentTypes = response.TreatmentTypes.map((c, i) => {
                    let t = { ...c, checked: false };
                    t.checked = queryStringFilters
                        && queryStringFilters.treatmenttypes
                        && queryStringFilters.treatmenttypes.indexOf(c.Name) != -1
                    return t;
                });
            }
            const containsAny = (input, search) => {
              search = search.toLowerCase()
              return input.split(',').filter(t => t.toLowerCase() === search).length > 0
            }
            if(response && response.DoctorTypeGroups){
                response.DoctorTypeGroups = response.DoctorTypeGroups.map((c, i) => { 
                    //select group if its part of QS and also not specificilly rejected by !
                    let groupSelectedInQuery = !!(queryStringFilters
                        && queryStringFilters.specialistgroups
                        && containsAny(queryStringFilters.specialistgroups, c.Name)
                        && !containsAny(queryStringFilters.specialistgroups, `!${c.Name}`));
                  c.DoctorTypes = c.DoctorTypes.map((b, j) => {
                      //select type if group is selected
                      let dt = { ...b, checked: groupSelectedInQuery };
                      //select type if type is part of QS but group not selected
                      //select type if type is part of QS or group selected
                      //reject type if type is rejected in part of QS but group selected
                      //reject type if type is rejected in part of QS and group not specified
                      dt.checked = !!(
                          queryStringFilters
                          && queryStringFilters.specialisttypes
                          && (groupSelectedInQuery || containsAny(queryStringFilters.specialisttypes, b.Name))
                          && !containsAny(queryStringFilters.specialisttypes, `!${b.Name}`)
                      );
                      return dt;
                    });
                    if (c.DoctorTypes.length === c.DoctorTypes.filter((c) => c.checked).length) {
                        c.DoctorTypes.forEach((element, index) => {
                                c.DoctorTypes[index].checked = false;
                        });
                    }
                  let dtg = { ...c, checked: false }; 
                  dtg.checked = groupSelectedInQuery;
                  return dtg;
              });
            }

            if(response && response.Languages){
              response.Languages = response.Languages.map((c, i) => {
                  let t = { ...c, checked: false };
                  t.checked = queryStringFilters
                      && queryStringFilters.languages
                      && queryStringFilters.languages.indexOf(c.Name) != -1
                  return t;
              });
          }

            response.searchEntityTypeFromQuery = queryStringFilters && queryStringFilters.searchentitytype;
            response.publicOnlyFromQuery = !!(queryStringFilters && queryStringFilters.publiconly);
            
            dispatch({
              type: AS_GET_FORM_INITIALISATION_DATA_SUCCESS,
              value: response
            })
          })
          .catch(error => {
            dispatch({
              type: AS_GET_FORM_INITIALISATION_DATA_FAILED,
              error: error.message
            })
          });
    }
}
